var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor add-tag" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("a-alert", {
            attrs: {
              type: "info",
              "show-icon": "",
              message: _vm.$t("chatbotv2.tagAddingDesc"),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.tagsToAdding"))),
          ]),
          _vm._v(" "),
          _c("TagDialog", {
            model: {
              value: _vm.clone.tags,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "tags", $$v)
              },
              expression: "clone.tags",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }